module.exports = __webpack_public_path__ + "static/media/mz.e2168b5d.svg";